import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ListPostbacksComponent from './ListPostbacks/ListPostbacks.container.js';
import { I18nContext } from 'utils/I18n/context';

const ListPostbackPage = () => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.postbackPage?.list || { 
        title: 'Postbacks', 
        conversionPostback: 'Conversion Postbacks' 
    };

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content tools">
                <div className="ibox postback">
                    <div className="ibox-title">
                        <h5>{staticNames.conversionPostback}</h5>
                    </div>
                    <ListPostbacksComponent />
                </div>
            </section>
        </React.Fragment>
    );
};

export default ListPostbackPage;
